// extracted by mini-css-extract-plugin
module.exports = {"query-count":"queryCount_query-count__20B26","inline":"queryCount_inline__2bQ_o"};